import { render, staticRenderFns } from "./tiaozhuan_debugger.vue?vue&type=template&id=05bbec18&scoped=true&"
import script from "./tiaozhuan_debugger.vue?vue&type=script&lang=js&"
export * from "./tiaozhuan_debugger.vue?vue&type=script&lang=js&"
import style0 from "./tiaozhuan_debugger.vue?vue&type=style&index=0&id=05bbec18&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bbec18",
  null
  
)

export default component.exports